import editorReducers from './editor';
export default editorReducers;
